// CLE-2659: option wording is taken verbatim from CMS-R-131 (Exp. 03/31/2029), the
// official Advance Beneficiary Notice of Non-coverage. Do not paraphrase — the text a
// patient signs is hashed into the ABN's documentSnapshot and is the legal record.
// `boldPrefix` is the leading portion CMS prints in bold on the printed form. It is purely
// presentational and must always be a literal prefix of `label`, which stays the single source of
// truth for the full text the patient reads and signs.
export const abnSelectionMedicareOptions = [
  {
    boldPrefix:
      "I want the item, test, service or care listed above, and I want Medicare to be billed for an official decision on payment, which I'll get on a Medicare Summary Notice (MSN).",
    label:
      "I want the item, test, service or care listed above, and I want Medicare to be billed for an official decision on payment, which I'll get on a Medicare Summary Notice (MSN). You can ask to be paid now. I understand that if Medicare doesn't pay, I'm responsible to pay, but I can appeal to Medicare by following the directions on the MSN. If Medicare does pay, you'll refund any payments I made to you, minus co-pays or deductibles.",
    value: "billMedicare",
  },
  {
    boldPrefix:
      "I want the item, test, service or care listed above, but don't bill Medicare.",
    label:
      "I want the item, test, service or care listed above, but don't bill Medicare. You can ask to be paid now and I'm responsible to pay. I understand that I can't appeal, since Medicare isn't billed.",
    value: "selfPay",
  },
  {
    boldPrefix: "I don't want the item, test, service or care listed above.",
    label:
      "I don't want the item, test, service or care listed above. I understand I'm not responsible for payment and I can't appeal to see if Medicare would pay.",
    value: "declineService",
  },
];

export const abnSelectionCommercialOptions = [
  {
    title: "YES, I want to receive these items or services.",
    label:
      "I want to proceed with the services listed above and have my claim filed with my insurance on file. I understand I may be asked to pay {{amount}} today and that I may be responsible for any amount my insurance does not cover.",
    value: "payNowAndFileInsurance",
  },
  {
    title: "YES, I want to receive these items or services.",
    label: `I want to proceed with the services listed above, but do NOT want to file charges with my insurance carrier. I understand and agree to be fully responsible for these services.

• The estimated cost for the services listed above is: {{amount}}
• I understand that it is due in full at least 2 (two) weeks prior to the scheduled date of service.`,
    value: "selfPayNoInsurance",
  },
  {
    title: "NO, I have decided not to receive these items or services.",
    label:
      "I will not receive these services. I understand with this choice, I am not responsible for payment, and I cannot appeal to see if insurance would cover them.",
    value: "declineWithoutFinancialResponsibility",
  },
];

export const medicareNote =
  "If you choose Option 1 or 2, we may help you use any other insurance you might have, but Medicare can't require us to do this.";
